
riot.tag2('ckeditor', '  <textarea name="{opts.name}" id="ck_{_riot_id}" value="{value}"></textarea>\n', '', '', function(opts) {
'use strict';

var self = this;

self.value = '';

Object.defineProperty(self.root, 'value', {
    get: function get() {
        return self.value;
    },
    set: function set(value) {
        self.value = value;
    }
});

self.one('updated', function () {
    var instance = CKEDITOR.replace('ck_' + self._riot_id, {
        extraPlugins: 'divarea,youtube'
    });

    instance.on('change', function () {
        var event = document.createEvent('Event');
        event.initEvent('change', true, true);
        self.root.dispatchEvent(event);
        $('#ck_' + self._riot_id).val(self.value);
    });

    localStorage.setItem('SE_section', opts.section);

    instance.on('instanceReady', function (event) {
        /* Активируем кнопку исходного кода */
        var element = $('.cke_button__source');
        element.on('click', function () {
            var elem = $('#cke_ck_' + self._riot_id + ' .cke_source');
            elem.on('input', function () {
                var event = document.createEvent('Event');
                event.initEvent('change', true, true);
                self.root.dispatchEvent(event);
                $('#ck_' + self._riot_id).val(elem[0].value);
            });
        });

        instance.setData(self.value);
        instance.resetUndo();
        Object.defineProperty(self, 'value', {
            get: function get() {
                return instance.getData();
            },
            set: function set(value) {
                if (value == null || value == undefined) value = '';
                if (instance.getData() !== value) {
                    instance.setData(value);
                    instance.resetUndo();
                }
            }
        });
    });

    self.on('unmount', function () {
        instance.destroy();
    });
});

self.on('mount', function () {
    self.value = opts.value || '';
    self.root.name = opts.name;
});
});


// WEBPACK FOOTER //
// ./components/ckeditor.tag